<template>
	<div class="slider" @click="onClick">
		<div class="info">
			<p class="info__label">{{ title }}</p>
			<p class="info__value">{{ stop }} (~{{ count }}/week)</p>
		</div>
		<div class="bar" ref="bar">
			<div class="bar__fill" :style="barStyle"></div>
			<div class="bar__dot" ref="dot" :style="dotStyle" @click.stop>
				<SliderDot @drag="onDrag" @click="onDragEnd" />
			</div>
		</div>
	</div>
</template>

<script>
import SliderDot from '@/components/SliderDot'

const clamp = (n, min, max) => Math.max(min, Math.min(n, max))
const eventX = e => (e.touches ? e.touches[0] : e).clientX

export default {
	name: 'slider',
	props: {
		title: String,
		count: Number,
		stop: String,
		value: {
			type: Number,
			validator: v => v >= 0 && v <= 1
		}
	},
	data() {
		return {
			barLeft: 0,
			barWidth: 0,
			dotWidth: 0,
			lastPct: this.value
		}
	},
	computed: {
		x() {
			const width = this.barWidth - this.dotWidth
			return width * this.value + this.dotWidth / 2
		},
		barStyle() {
			return { width: this.x + 'px' }
		},
		dotStyle() {
			return { left: this.x + 'px' }
		}
	},
	methods: {
		measure() {
			this.barLeft = this.$refs.bar.offsetLeft
			this.barWidth = this.$refs.bar.offsetWidth
			this.dotWidth = this.$refs.dot.offsetWidth
		},
		getPercent(cx) {
			const left = this.barLeft + this.dotWidth / 2
			const width = this.barWidth - this.dotWidth
			return clamp(cx - left, 0, width) / width
		},
		onClick(event) {
			this.onDrag(event)
			this.onDragEnd()
		},
		onDrag(event) {
			const x = eventX(event)
			const pct = this.getPercent(x)
			if (pct !== this.lastPct) {
				this.lastPct = pct
				this.$emit('input', pct)
			}
		},
		onDragEnd() {
			this.$emit('dragend')
		}
	},
	mounted() {
		this.measure()
	},
	watch: {
		'$screen.width'() {
			this.measure()
		}
	},
	components: {
		SliderDot
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';

.slider + .slider {
	margin-top: 1.875rem;
}

.info {
	display: flex;
	margin-bottom: 0.875rem;

	&__label,
	&__value {
		font-size: 0.875rem;
		margin: 0;
		color: $green-44;
	}

	&__label {
		flex-grow: 1;
		font-weight: bold;
	}
}

.bar {
	font-size: 1rem;
	$bar-height: 0.5rem;
	$dot-rad: 0.75rem;

	position: relative;
	width: 100%;
	margin: $dot-rad - $bar-height / 2 0;
	height: $bar-height;
	border-radius: $bar-height / 2;
	background-color: $grey-96;
	touch-action: none;

	&__fill {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		background-color: $green-65;
		border-radius: $bar-height / 2;
	}

	&__dot {
		position: absolute;
		top: 50%;
		width: $dot-rad * 2;
		height: $dot-rad * 2;
		transform: translate3d(-50%, -50%, 0);
		user-select: none;
		cursor: pointer;
	}
}
</style>
